import { useContext } from 'react'
import styles from "../../../components/Lessons/LessonModule/styles.module.scss"
import { AuthContext } from "AuthContext"
import { CurriculumSection, TopicStudentAnswers } from 'shared/types/curriculumTypes'
import DrawingImageButton from 'pages/Dashboard/Teacher/Grades/Submission/components/DrawingImageButton'
import SectionQuestionInput from './SectionQuestionInput'
import { AssignmentContext } from 'components/Assignment/AssignmentContext'
import { TopicFeedbackContext } from "components/Assignment/contexts/TopicFeedbackContext"
import ToolTip from "components/General/ToolTip"
import TeacherFeedback from "components/Assignment/components/TeacherFeedback"

interface SectionQuestionsProps {
    currentSection: CurriculumSection
    studentAnswers: TopicStudentAnswers
    initialStudentAnswers: TopicStudentAnswers
    handleAnswerChange: (sectionNum: number, questionsNum: number, answer: string, drawingResponse: string) => void
}


function SectionQuestions({ currentSection, studentAnswers, initialStudentAnswers, handleAnswerChange } : SectionQuestionsProps) {
    const authContext = useContext(AuthContext)
    const { demoMode, reworkAssignmentMode } = useContext(AssignmentContext)
    const { feedback } = useContext(TopicFeedbackContext)

    const isTeacher = authContext.isLoggedIn && !authContext.isStudent
    const sectionNumber = currentSection.sortOrder

    return (
        <ol className='list-group list-group-flush text-start'>
            {currentSection.questions?.map((question, index) => {
                const questionId = `s${sectionNumber}-q${question.sortOrder}` // used for highlighting the incomplete question
                const isTableType = question.type === "Table" || (question.question.includes("<table") && (question.question.includes("<input") || question.question.includes("<textarea")))
                const questionFeedback = feedback.find(r => r.topicQuestionId === question.id)
                const questionIsGraded = questionFeedback?.grade != null && reworkAssignmentMode

                return <li key={index} className='list-group-item'>
                        <h6 className={`fw-bold ${isTableType ? "question-table" : ""}`} id={questionId}>
                            {index + 1}. <span dangerouslySetInnerHTML={{ __html: question.question }}></span>
                            <i className="incompleteExclamation d-none fas fa-exclamation-circle text-warning position-absolute" style={{top: "2px", left: "0"}} />
                            {questionIsGraded && <ToolTip title="graded"><i className="fas fa-circle-check text-success fs-3 ms-1" /></ToolTip>}
                        </h6>
                        <SectionQuestionInput
                            currentSection={currentSection}
                            handleAnswerChange={handleAnswerChange}
                            question={question}
                            sectionNumber={sectionNumber}
                            studentAnswers={studentAnswers}
                            initialStudentAnswers={initialStudentAnswers}
                        />
                        {isTeacher && !demoMode && 
                            <strong className="text-success d-block my-3">
                                {question.type !== "Drawing" &&
                                    <>
                                        <span>Correct Answer: </span>
                                        <span className={styles.correctAnswer} dangerouslySetInnerHTML={{ __html: question.correctAnswer}} />
                                    </>}
                            {question.type === "Drawing" &&
                                    <div className="d-flex justify-content-center">
                                        <DrawingImageButton 
                                            drawingUrl={question.exampleImageUrl}
                                            title="Example Drawing" 
                                            optionalAnswer={question.correctAnswer} />
                                    </div>}
                            </strong>}
                            <TeacherFeedback grade={questionFeedback?.grade} comment={questionFeedback?.comment} show={reworkAssignmentMode} />
                    </li>
            })}
        </ol>
    )
}

export default SectionQuestions
